"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppContext = void 0;
var storefront_client_1 = require("@rechargeapps/storefront-client");
var React = __importStar(require("react"));
var react_query_1 = require("react-query");
var react_router_dom_1 = require("react-router-dom");
var existing_customer_new_bundle_1 = require("../../misc/existing-customer-new-bundle");
var recharge_bundles_1 = require("../../misc/recharge-bundles");
var recharge_storefront_1 = require("../../misc/recharge-storefront");
var store_credit_1 = require("../../misc/store-credit");
var fetch_user_geolocation_1 = require("../../utils/fetch-user-geolocation");
var api_1 = require("../account-v3/api");
var loading_modal_1 = __importDefault(require("../account-v3/components/loading_modal"));
var update_subscription_1 = require("../account-v3/mutations/update-subscription");
var bundler_unavailable_modal_1 = __importDefault(require("../bundler-v2/components/bundler-unavailable-modal"));
var is_variant_available_1 = __importDefault(require("../bundler/is-variant-available"));
var existing_customer_new_bundle_modal_1 = __importDefault(require("../essentials-bundler/components/existing-customer-new-bundle-modal"));
var nav_bar_1 = __importDefault(require("./nav-bar"));
var progress_bar_1 = __importDefault(require("./progress-bar"));
var review_1 = __importDefault(require("./routes/review"));
var select_size_1 = __importDefault(require("./routes/select-size"));
var select_vitamins_1 = __importDefault(require("./routes/select-vitamins"));
var createContext = React.createContext, useMemo = React.useMemo, useState = React.useState;
exports.AppContext = createContext({
    addChoice: function () { return undefined; },
    availableChoices: [],
    availableSizes: [],
    changeSize: function () { return undefined; },
    choices: [],
    isSubmittingBundle: false,
    setLeftSideImage: function () { return null; },
    size: undefined,
    subChoice: function () { return undefined; },
    submitBundle: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, undefined];
    }); }); },
    totalNumChoices: 0,
});
var scrollContainerDivID = 'vitamin-bundler-scroll-cnt';
var App = function (props) {
    var _a;
    var _b = __read(useState(false), 2), showUnavailableInRegionModal = _b[0], setShowUnavailableInRegionModal = _b[1];
    var llaShop = (function () {
        var domain = process.env.PERMANENT_DOMAIN || window.permanentDomain || '';
        if (domain.startsWith('hbca-launched'))
            return 'hbca';
        return 'hbus';
    })();
    (0, react_query_1.useQuery)([fetch_user_geolocation_1.getOrFetchAndUpdateCountryCodeByIpCookieUseQueryKey], fetch_user_geolocation_1.getOrFetchAndUpdateCountryCodeByIpCookie, {
        onSuccess: function (data) {
            var UNSUPPORTED_COUNTRY_CODES = llaShop === 'hbus' ? ['CA'] : [];
            if (UNSUPPORTED_COUNTRY_CODES.includes(data.countryCode)) {
                setShowUnavailableInRegionModal(true);
            }
        },
        enabled: !!props.settings.selectSize.blockAccessByUserRegion,
    });
    if (!props) {
        return null;
    }
    var existingBundle = props.existingBundle, location = props.location, products = props.products, shippingIntervalFrequencies = props.shippingIntervalFrequencies, shippingIntervalUnitType = props.shippingIntervalUnitType, subscriptionId = props.subscriptionId, subscriptionUrlLocation = props.subscriptionUrlLocation, settings = props.settings, mainRcBundleProduct = props.mainRcBundleProduct;
    var mainBundleProduct = useMemo(function () { return products.find(function (p) { return p.tags.includes('Bundler App Main Product'); }); }, []);
    if (!mainBundleProduct) {
        return null;
    }
    var availableSizes = useMemo(function () { return mainBundleProduct.variants.map(function (o) { return parseInt(o.option1, 10); }); }, []);
    var availableChoices = useMemo(function () {
        return products
            .filter(function (p) { return p.tags.includes('Bundler App Possible Choices'); })
            .reduce(function (arr, product) {
            return arr.concat(product.variants.map(function (variant) { return ({ product: product, variant: variant }); }));
        }, []);
    }, []);
    // frequency is unchangeable
    // the assumption is the metafield is [15, 30, 60, 90]
    // so we'll default to 30
    var frequency = useMemo(function () { return Number(shippingIntervalFrequencies[1]); }, []);
    var _c = __read(useState(existingBundle ? parseInt(existingBundle.subscription.variant_title, 10) : undefined), 2), size = _c[0], setSize = _c[1];
    var _d = __read(useState(function () {
        if (existingBundle) {
            var children = existingBundle.children; // coddle typescript
            return children.reduce(function (arr, child) {
                var product = products.find(function (p) { return p.id === child.shopify_product_id; });
                var variant = product === null || product === void 0 ? void 0 : product.variants.find(function (v) { return v.id === child.shopify_variant_id; });
                return product && variant && (0, is_variant_available_1.default)(variant) ? arr.concat({ product: product, variant: variant, quantity: child.quantity }) : arr;
            }, []);
        }
        return [];
    }), 2), choices = _d[0], setChoices = _d[1];
    var _e = __read(useState(false), 2), isSubmittingBundle = _e[0], setIsSubmittingBundle = _e[1];
    var _f = __read(useState(undefined), 2), leftSideImage = _f[0], setLeftSideImage = _f[1];
    var queryClient = (0, react_query_1.useQueryClient)();
    var _g = (0, react_query_1.useMutation)("updateSubscription", function (variables) { return (0, api_1.getSubscriptionAPIClient)().request(update_subscription_1.UPDATE_SUBSCRIPTION, variables); }, {
        onSuccess: function (updatedData) { return __awaiter(void 0, void 0, void 0, function () {
            var updatedSubscriptionId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.invalidateQueries('getCustomerSubscriptions')];
                    case 1:
                        _a.sent();
                        updatedSubscriptionId = updatedData.updateSubscription.subscription.id;
                        window.location.href = "".concat(subscriptionUrlLocation, "/").concat(updatedSubscriptionId);
                        return [2 /*return*/];
                }
            });
        }); },
    }), updateSubscription = _g.mutateAsync, isUpdatingSubscription = _g.isLoading, error = _g.error;
    var selectedBundleVariant = useMemo(function () { return (size ? mainBundleProduct.variants.find(function (_a) {
        var option1 = _a.option1;
        return option1 === size.toString();
    }) : undefined); }, [size]);
    var totalNumChoices = useMemo(function () { return choices.reduce(function (sum, c) { return sum + c.quantity; }, 0); }, [choices]);
    var totalBundlePrice = useMemo(function () {
        var e_1, _a;
        var price = 0;
        if (selectedBundleVariant) {
            price += selectedBundleVariant.price;
        }
        try {
            for (var choices_1 = __values(choices), choices_1_1 = choices_1.next(); !choices_1_1.done; choices_1_1 = choices_1.next()) {
                var _b = choices_1_1.value, variant = _b.variant, quantity = _b.quantity;
                price += variant.price * quantity;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (choices_1_1 && !choices_1_1.done && (_a = choices_1.return)) _a.call(choices_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return price;
    }, [size, choices]);
    // set up existing customer new bundle variables
    var _h = (0, existing_customer_new_bundle_1.useCreateNewBundle)('Vitamin'), createNewBundleForExistingCustomer = _h.finalSubmit, createNewBundleForExistingCustomerError = _h.error, isCreatingNewBundleForExistingCustomer = _h.isCreatingNewBundleForExistingCustomer, didExistingCustomerCreateNewBundle = _h.didExistingCustomerCreateNewBundle, existingCustomerNewBundleParams = _h.queryParams, getExistingCustomerNewBundleSavingsAndDiscount = _h.getSavingsAndDiscount;
    // recalculate the existing-customer-new-bundle-savings when the price changes
    var _j = useMemo(function () { return getExistingCustomerNewBundleSavingsAndDiscount(Number(totalBundlePrice)); }, [totalBundlePrice]), existingCustomerNewBundleSavings = _j.savings, existingCustomerNewBundleDiscount = _j.discount;
    var addChoice = function (choice) {
        if (choice) {
            var existingIdx = choices.findIndex(function (c) { return c.variant.id === choice.variant.id; });
            var newChoices = choices.slice(0);
            if (existingIdx !== -1) {
                newChoices[existingIdx] = __assign(__assign({}, choice), { quantity: newChoices[existingIdx].quantity + 1 });
            }
            else {
                newChoices.push(__assign(__assign({}, choice), { quantity: 1 }));
            }
            setChoices(newChoices);
        }
    };
    var subChoice = function (choice) {
        if (choice) {
            var existingIdx = choices.findIndex(function (c) { return c.variant.id === choice.variant.id; });
            var newChoices = choices.slice(0);
            if (existingIdx !== -1) {
                if (newChoices[existingIdx].quantity === 1) {
                    newChoices.splice(existingIdx, 1);
                }
                else {
                    newChoices[existingIdx].quantity--;
                }
            }
            setChoices(newChoices);
        }
    };
    var changeSize = function (newSize) {
        // if sizing down, remove all choices
        if (size && newSize && newSize < size) {
            setChoices([]);
        }
        setSize(newSize);
    };
    useMemo(function () {
        var el = document.getElementById(scrollContainerDivID);
        if (el) {
            el.scrollTop = 0;
        }
    }, [location.pathname]);
    var pathBack = useMemo(function () {
        switch (location.pathname) {
            case '/vitamins':
                return '/';
            case '/review':
                return '/vitamins';
        }
    }, [location.pathname]);
    var pathNext = useMemo(function () {
        switch (location.pathname) {
            case '/':
                return '/vitamins';
            case '/vitamins':
                return !!existingBundle ? undefined : '/review';
        }
    }, [location.pathname]);
    var canGoNext = useMemo(function () {
        switch (location.pathname) {
            case '/':
                return !!size;
            case '/vitamins':
                return totalNumChoices === size;
            case '/review':
                return !!size && totalNumChoices === size;
            default:
                return false;
        }
    }, [size, totalNumChoices, location.pathname]);
    var _k = __read(useMemo(function () {
        switch (location.pathname) {
            case '/vitamins':
                return [2 / 3, '2/3'];
            case '/review':
                return [1, '3/3'];
            default:
                return [1 / 3, '1/3'];
        }
    }, [location.pathname]), 2), progressWidth = _k[0], progressBarText = _k[1];
    var addToCart = function (bundleItemParams) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, window.cartApp.add(bundleItemParams)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var updateExistingBundle = function (bundleItemParams) { return __awaiter(void 0, void 0, void 0, function () {
        var itemUpdates;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!existingBundle || !updateSubscription) {
                        return [2 /*return*/];
                    }
                    itemUpdates = bundleItemParams.map(function (_a) {
                        var _b = __read(_a, 2), variantId = _b[0], obj = _b[1];
                        return ({
                            properties: obj ? JSON.stringify(obj.properties) : '',
                            quantity: obj && obj.quantity ? obj.quantity : 1,
                            variantId: variantId,
                        });
                    });
                    return [4 /*yield*/, updateSubscription({
                            itemUpdates: itemUpdates,
                            subscriptionId: existingBundle.subscription.id,
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var submitBundle = function () { return __awaiter(void 0, void 0, void 0, function () {
        var bundleId, sharedProps, childProps, parentProps, bundleItemParams, choices_2, choices_2_1, _a, variant, quantity, product, itemProperties, params_1, shopifyVariantId, params, cdnBundleSettings;
        var e_2, _b;
        var _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!selectedBundleVariant) {
                        return [2 /*return*/];
                    }
                    setIsSubmittingBundle(true);
                    bundleId = ((_c = existingBundle === null || existingBundle === void 0 ? void 0 : existingBundle.subscription.properties.find(function (_a) {
                        var name = _a.name;
                        return name === 'bundle_id';
                    })) === null || _c === void 0 ? void 0 : _c.value) || new Date().getTime().toString();
                    sharedProps = (function () {
                        var properties = {};
                        // We still include the original_bundle_value property for recharge bundles because the cart uses it
                        properties.original_bundle_value = choices.reduce(function (sum, _a) {
                            var variant = _a.variant, quantity = _a.quantity;
                            return sum + Number(variant.compare_at_price || variant.price) * quantity;
                        }, 0) / 100;
                        if (!settings.app.rcBundlesForAcquisitionEnabled) {
                            properties.charge_interval_frequency = frequency;
                            properties.subscription_id = subscriptionId;
                            properties.shipping_interval_frequency = frequency;
                            properties.shipping_interval_unit_type = shippingIntervalUnitType;
                        }
                        return properties;
                    })();
                    childProps = __assign(__assign({}, sharedProps), { parent_bundle_id: bundleId });
                    parentProps = __assign(__assign({}, sharedProps), { bundle_id: bundleId });
                    bundleItemParams = [
                        {
                            createItemParams: [selectedBundleVariant.id, { properties: parentProps }],
                            variant: __assign(__assign({}, selectedBundleVariant), { product: { id: mainBundleProduct.id } }),
                        },
                    ];
                    try {
                        for (choices_2 = __values(choices), choices_2_1 = choices_2.next(); !choices_2_1.done; choices_2_1 = choices_2.next()) {
                            _a = choices_2_1.value, variant = _a.variant, quantity = _a.quantity, product = _a.product;
                            itemProperties = __assign(__assign({}, childProps), { compare_at_price: Number(variant.compare_at_price || variant.price) * 100 });
                            bundleItemParams.push({
                                createItemParams: [variant.id, { quantity: quantity, properties: itemProperties }],
                                variant: __assign(__assign({}, variant), { product: { id: product.id } }),
                            });
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (choices_2_1 && !choices_2_1.done && (_b = choices_2.return)) _b.call(choices_2);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    if (!existingBundle) return [3 /*break*/, 2];
                    return [4 /*yield*/, updateExistingBundle(bundleItemParams.map(function (item) { return item.createItemParams; }))];
                case 1:
                    _e.sent();
                    return [3 /*break*/, 12];
                case 2:
                    if (!existingCustomerNewBundleParams) return [3 /*break*/, 7];
                    params_1 = bundleItemParams.map(function (item) { return item.createItemParams; });
                    shopifyVariantId = (function () {
                        if (settings.app.rcBundlesForAcquisitionEnabled) {
                            if (!mainRcBundleProduct)
                                throw new Error('Recharge bundles enabled but mainRcBundleProduct is missing');
                            return mainRcBundleProduct.variants[0].id; // we expect there to only be one variant, and it's the one we want
                        }
                        return params_1[0][0]; // main bundle product variant id
                    })();
                    _e.label = 3;
                case 3:
                    _e.trys.push([3, , 5, 6]);
                    return [4 /*yield*/, createNewBundleForExistingCustomer(__assign(__assign({}, existingCustomerNewBundleParams), { shopifyVariantId: shopifyVariantId, shippingIntervalUnitType: shippingIntervalUnitType, frequency: Number(frequency), bundleId: bundleId, bundleItemParams: bundleItemParams.map(function (item) { return item.createItemParams; }) }))];
                case 4:
                    _e.sent();
                    return [3 /*break*/, 6];
                case 5:
                    setIsSubmittingBundle(false);
                    return [7 /*endfinally*/];
                case 6: return [3 /*break*/, 12];
                case 7:
                    (_d = window.dataLayer) === null || _d === void 0 ? void 0 : _d.push({ event: 'vitaminBundle__addToCart' });
                    params = void 0;
                    if (!settings.app.rcBundlesForAcquisitionEnabled) return [3 /*break*/, 9];
                    return [4 /*yield*/, (0, storefront_client_1.getCDNBundleSettings)(mainRcBundleProduct.id)];
                case 8:
                    cdnBundleSettings = _e.sent();
                    if (!cdnBundleSettings)
                        throw new Error("Failed to fetch bundle settings for product id ".concat(mainRcBundleProduct.id));
                    params = (0, recharge_bundles_1.buildDynamicRechargeBundle)({
                        choices: bundleItemParams,
                        cdnBundleSettings: cdnBundleSettings,
                        mainRcBundleProduct: mainRcBundleProduct,
                        shippingIntervalFrequency: frequency,
                        shippingIntervalUnitType: shippingIntervalUnitType,
                    });
                    return [3 /*break*/, 10];
                case 9:
                    params = bundleItemParams.map(function (item) { return item.createItemParams; });
                    _e.label = 10;
                case 10: return [4 /*yield*/, addToCart(params)];
                case 11:
                    _e.sent();
                    setIsSubmittingBundle(false);
                    _e.label = 12;
                case 12: return [2 /*return*/];
            }
        });
    }); };
    // prefetch this query for later use on the review screen
    var isLoggedIn = !!((_a = window.customer) === null || _a === void 0 ? void 0 : _a.id);
    (0, store_credit_1.useCustomerCreditAccount)({ enabled: !!isLoggedIn });
    // Initialize the recharge storefront sdk - we don't need a session so we don't wait for it
    var result = (0, recharge_storefront_1.useInitRechargeStorefrontSdk)();
    if (!result.initialized)
        return null;
    var contextValue = {
        addChoice: addChoice,
        availableChoices: availableChoices,
        availableSizes: availableSizes,
        canGoNext: canGoNext,
        changeSize: changeSize,
        choices: choices,
        existingCustomerNewBundleParams: existingCustomerNewBundleParams,
        isEditingExistingBundle: !!existingBundle,
        isSubmittingBundle: isSubmittingBundle,
        frequency: frequency,
        leftSideImage: leftSideImage,
        mainBundleProduct: mainBundleProduct,
        pathBack: pathBack,
        pathNext: pathNext,
        size: size,
        subChoice: subChoice,
        submitBundle: submitBundle,
        totalBundlePrice: totalBundlePrice,
        totalNumChoices: totalNumChoices,
        setLeftSideImage: setLeftSideImage,
        shippingIntervalUnitType: shippingIntervalUnitType,
        existingCustomerNewBundleSavings: existingCustomerNewBundleSavings,
        existingCustomerNewBundleDiscount: existingCustomerNewBundleDiscount,
    };
    return (React.createElement(exports.AppContext.Provider, { value: contextValue },
        React.createElement(loading_modal_1.default, { error: createNewBundleForExistingCustomerError, isLoading: isCreatingNewBundleForExistingCustomer }),
        React.createElement(existing_customer_new_bundle_modal_1.default, { isOpen: didExistingCustomerCreateNewBundle }),
        React.createElement(bundler_unavailable_modal_1.default, { isOpen: showUnavailableInRegionModal, message: 'Sorry, the Vitamin Bundle is not available in your region.' }),
        React.createElement("div", { className: 'grid-x height-100 width-100', style: { maxWidth: '100%' } },
            !existingBundle && (React.createElement("div", { key: leftSideImage, className: 'cell show-for-medium bg-cover bg-center', style: { backgroundImage: "url(".concat(leftSideImage, ")"), width: '50%' } }, "\u00A0")),
            React.createElement("div", { className: 'cell auto grid-y height-100' },
                !existingBundle && React.createElement(progress_bar_1.default, { text: progressBarText, width: progressWidth }),
                React.createElement("div", { className: 'cell auto overflow-y-auto bg-white', id: scrollContainerDivID },
                    React.createElement(react_router_dom_1.Switch, null,
                        React.createElement(react_router_dom_1.Route, { exact: true, path: '/', component: select_size_1.default }),
                        React.createElement(react_router_dom_1.Route, { exact: true, path: '/vitamins', component: select_vitamins_1.default }),
                        React.createElement(react_router_dom_1.Route, { exact: true, path: '/review', component: review_1.default }))),
                React.createElement(nav_bar_1.default, null)))));
};
exports.default = (0, react_router_dom_1.withRouter)(App);
